import { ready, selector, inputText, api } from './helpers/utils.js'
import { inlineError, clearInlineError } from './helpers/toast.js'

ready(() => {
  const form = selector<HTMLFormElement>('#login_form')
  const username = selector<HTMLInputElement>('#username_input')
  const password = selector<HTMLInputElement>('#password_input')
  const remember = selector<HTMLInputElement>('#remember_checkbox')
  const formError = selector<HTMLElement>('#form_error')

  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    clearInlineError(formError)

    if (inputText(username).length === 0 || inputText(password).length === 0) {
      inlineError(formError, 'yo... username and password, both')
      return
    }

    const res = await api('/api/v1/auth', {
      body: {
        username: inputText(username),
        password: password.value,
        remember: remember.checked,
      },
    })

    if (res.ok) {
      window.location.href = '/chat'
    } else {
      inlineError(formError, 'try again')
    }
  })
})
